export default "__VITE_ASSET__a7VH3A1u__"